import { shippingDocumentsContracts } from "./shipping-documents.contract";

export const supplyChainManagementContracts = {
  shippingDocuments: shippingDocumentsContracts,
} as const;

export * from "./shipping-documents.contract";
